import React from 'react'
import Image from 'next/image'

export default function CKABenefits2() {
  const promotionalBenefits = [
    {
      id: 1,
      title: "Access to our next CKA<sup style='font-size: 16px;'>®</sup>-only Engaged Learning virtual event",
      description: "<em>Client Discipleship Conversations That Inspire Action</em>: Learn proven ways of engaging clients in conversations about stewardship and generosity to use with clients immediately.<br/><br/>Registration required (free), and space is limited."
    },
    {
      id: 2,
      title: "The CKA<sup style='font-size: 16px;'>®</sup> Growth Kit",
      description: "Market your CKA<sup style='font-size: 14px;'>®</sup> designation with this newly developed suite of tools. It's like having your own marketing team."
    },
    {
      id: 3,
      title: "Exclusive access to a special <em>Ask Michael Kitces Anything</em> session in February",
      description: "Featuring industry thought leader and podcaster Michael Kitces at the Redeeming Money 2026 conference"
    }
  ]

  return (

    <div className="px-4 self-stretch py-14 relative bg-[#FBB35C] flex flex-col justify-start items-center gap-2.5 overflow-hidden">
      {/* Pattern Background */}
      <div className="hidden md:block md:absolute left-0 top-0 bottom-0 w-1/3">
        <Image
          src="/static/images/cka_landing/Pattern 2.png"
          alt="Background pattern"
          fill
          className="object-cover"
        />
      </div>

      <div className="mx-auto max-w-7xl w-full relative z-10 flex flex-col justify-start items-center gap-12">
        {/* Header */}
        <div className="w-full max-w-4xl flex flex-col justify-start items-center gap-3">
          <div  className="w-full text-center text-blue-950 text-2xl md:text-4xl font-medium font-['Lora']">
            This Week Only!
          </div>
          <div className="w-full text-center" style={{fontSize:'16px'}}>
            <span className="text-blue-950 text-lg md:text-2xl font-normal font-['Instrument-Sans']">
              Start your CKA<sup style={{fontSize:'16px'}} className="text-blue-950 text-base md:text-2xl font-normal font-['Instrument-Sans']">®</sup>
            </span>
        
            <span className="text-blue-950 text-base md:text-2xl font-normal font-['Instrument-Sans']">
              {' '}certification this week and receive these exclusive benefits.
            </span>
          </div>
        </div>

        {/* Benefits Cards */}
        <div className="w-full flex flex-col">
          <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {promotionalBenefits.map((benefit) => (
              <div key={benefit.id} className="w-full p-8 bg-sky-100 rounded-3xl border-2 border-blue-200 flex flex-col justify-start items-start gap-4">
                <div className="w-full flex flex-col justify-start items-start gap-4">
                  {/* Checkmark Icon */}
                  <div className="w-8 h-8  flex justify-center items-center relative">
                    <Image
                      src="/static/images/cka_landing/check2.png"
                      alt="Checkmark"
                      fill
                   
                    />
                  </div>
                  
                  {/* Title */}
                  <div className="w-full">
                    <span className="text-blue-950 text-lg md:text-3xl font-semibold font-['Instrument-Sans']" dangerouslySetInnerHTML={{
                      __html: benefit.title
                    }} />
                  </div>
                </div>
                
                {/* Description */}
                <div className="w-full flex flex-col justify-start items-start gap-10">
                  <div className="w-full pb-6 flex flex-col justify-start items-start gap-4">
                    <div className="w-full flex flex-col justify-start items-start gap-6">
                      <div className="w-full">
                        <span className="text-blue-950 text-base md:text-lg font-normal font-['Instrument-Sans'] leading-normal" dangerouslySetInnerHTML={{
                          __html: benefit.description
                        }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>

  )
}